import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { ReserveButton } from 'components/CollapsibleResource/styles';
import { BottomDrawer } from 'components/molecules/BottomDrawer';

interface BottomSheetCategorySelectorProps {
  children?: ReactNode;
  onClose: () => void;
}

const BottomSheetCategorySelector = ({
  children,
  onClose,
}: BottomSheetCategorySelectorProps) => {
  const { t: translate } = useTranslation();

  return (
    <BottomDrawer
      size="full"
      open
      heading={translate('filterExperiences')}
      onClose={onClose}
    >
      <CategoriesList>{children}</CategoriesList>
      <ReserveButton onClick={onClose}>{translate('apply')}</ReserveButton>
    </BottomDrawer>
  );
};

const CategoriesList = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin-top: 32px;
  margin-bottom: 32px;
`;

export default BottomSheetCategorySelector;
